//@flow

import React, { Component, Fragment } from 'react';
import {
  FormGroup,
  // Label,
  Input,
  Button,
  FormFeedback,
  InputGroup,
  InputGroupAddon,
} from 'reactstrap';
import isEmail from 'validator/lib/isEmail';
import { Link } from 'react-router-dom';

type Credentials = { email: string, password: string, fullname?: string };

type State = {
  data: Credentials,
  errors: {
    email?: string,
    password?: string,
    security?: string,
    captcha?: string,
    fullname?: string,
  },
  seePassword: boolean,
  // isNotiCheck: boolean,
  isPolicyCheck: boolean,
  isErrors: boolean,
};

type Props = {
  loading: boolean,
  buttonText: string,
  loadingTextIndicator: string,
  isSignUpForm: boolean,
  submit: (data: Credentials) => void,
  clearServerError: () => void,
};

const initialState = {
  data: { email: '', password: '', fullname: '' },
  errors: {},
  isPolicyCheck: false,
  seePassword: false,
  isErrors: true,
};

const styles = {
  email: { textTransform: 'lowercase' },
  captcha: { padding: '0 0 6px', transform: 'scale(0.87)', transformOrigin: '0 0' },
};

export default class FormState extends Component<Props, State> {
  static defaultProps = {
    isSignUpForm: true,
    clearServerError: () => {},
    loadingTextIndicator: 'JOINING',
    buttonText: 'JOIN HONEYGUIDE',
  };

  state = { ...initialState };

  handleChange = event => {
    const { data, errors } = this.state;
    const { name, value } = event.currentTarget;

    const key: string = name;
    const fieldValue: string = value;

    this.props.clearServerError();

    this.setState({
      data: { ...data, [key]: fieldValue },
      errors: { ...errors, [key]: '' },
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const { data } = this.state;
    const { submit, isSignUpForm } = this.props;

    const errors = this.validate(data);
    this.setState({ errors });

    //we are checking the errors from the variable above not the state
    //since the errors in state is only used to show the errors.
    const noErrors = Object.keys(errors).length === 0;
    if (noErrors) {
      if (!isSignUpForm) {
        const loginData = { email: data.email, password: data.password };
        submit(loginData);
      } else {
        submit(data);
      }
    }
  };

  validate = (data: Credentials) => {
    const { email, password, fullname } = data;
    const errors = {};
    const fullNameRegex = /[^\s]/;

    if (!isEmail(email)) errors.email = 'Please enter a valid email';
    if (!password) errors.password = 'Please enter a valid password';
    if (!email) errors.email = 'Please enter a valid email';
    if (password.length > 0 && password.length < 6)
      errors.password = 'Minimum of 6 characters required, captain!';

    //validation check when the user registers
    if (this.isTheTypeRegister()) {
      const { isPolicyCheck } = this.state;

      if (!fullNameRegex.test(fullname)) errors.fullname = 'Please enter a valid name';
      if (!isPolicyCheck) errors.security = 'Please confirm the boxes';
    }

    return errors;
  };

  isTheTypeRegister = () => !!this.props.isSignUpForm;

  onCheckboxChange = e => {
    this.setState({ [e.target.name]: e.target.checked });
    this.emptyErrors('security');
  };

  onCaptchaChecked = e => {
    this.setState({ isCaptchaCheck: true });
    this.emptyErrors('captcha');
  };

  //when the errors is shown, the user checks to redeem the error
  //therefore, the error message should be removed when the user
  //makes action to negate the error.
  emptyErrors = (key: string) => {
    const { errors } = this.state;
    const isErrors = errors[key] && errors[key].length > 0;

    if (isErrors) errors[key] = '';
  };

  togglePassword = () => this.setState({ seePassword: !this.state.seePassword });

  componentDidUpdate(prevProps: Props) {
    const didUserChangeLoginOrSignup = prevProps.buttonText !== this.props.buttonText;

    if (didUserChangeLoginOrSignup) this.setState({ ...initialState });
  }

  render() {
    const {
      data: { email, password, fullname },
      errors,
      seePassword,
    } = this.state;
    const { loading, buttonText, loadingTextIndicator, isSignUpForm } = this.props;

    return (
      <Fragment>
        {isSignUpForm && (
          <FormGroup>
            <Input
              type="name"
              name="fullname"
              id="name"
              value={fullname}
              onChange={this.handleChange}
              placeholder="full name"
            />
            <FormFeedback className="error">{errors.fullname}</FormFeedback>
          </FormGroup>
        )}

        <FormGroup>
          <Input
            type="name"
            name="email"
            id="email"
            value={email}
            onChange={this.handleChange}
            placeholder="email address"
            style={styles.email}
          />
          <FormFeedback className="error">{errors.email}</FormFeedback>
        </FormGroup>

        <FormGroup className="mb-05">
          <InputGroup>
            <Input
              type={seePassword ? 'text' : 'password'}
              name="password"
              id="password"
              value={password}
              onChange={this.handleChange}
              placeholder="Enter your password"
            />
            <InputGroupAddon onClick={this.togglePassword} addonType="append">
              <span className="input-group-text">
                <i className="icon icon-hg-eye" />
              </span>
            </InputGroupAddon>
          </InputGroup>
          <FormFeedback className="error">{errors.password}</FormFeedback>
        </FormGroup>

        {/* {!isSignUpForm && (
          <FormGroup>
            <Label check>
              <Input type="checkbox" />
              <span /> Remember me
            </Label>
            <Link to="/forgot-password" className="forget float-right" target="_blank">
              Forgot password?
            </Link>
          </FormGroup>
        )} */}

        {isSignUpForm && (
          <Fragment>
            <ul className="permi">
              <li>
                <label>
                  <input
                    type="checkbox"
                    name="isPolicyCheck"
                    onChange={this.onCheckboxChange}
                  />
                  <span />
                  By submitting this form I agree to HoneyGuide`s{' '}
                  <Link to="/policies/terms-services" target="_blank">
                    Terms of Services
                  </Link>{' '}
                  and{' '}
                  <Link to="/policies/privacy" target="_blank">
                    Privacy Policies
                  </Link>
                </label>
              </li>
              {/* <li>
                <label>
                  <input
                    type="checkbox"
                    name="isNotiCheck"
                    onChange={this.onCheckboxChange}
                  />
                  <span /> To facilitate bookings, HoneyGuide might send
                  notifications. I agree to receive such notifications.
                </label>
              </li> */}
            </ul>
            <div className="error">{errors.security}</div>
          </Fragment>
        )}

        <Button
          type="submit"
          color="yellow"
          className={loading ? 'btn-login btn-loading' : 'btn-login btn-sign'}
          onClick={this.handleSubmit}
        >
          {loading ? loadingTextIndicator : buttonText}
        </Button>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/FormState.jsx